import React, { FC, useEffect, useMemo, useRef, useState } from "react";
import { useEndpoints } from "../../hooks/useEndpoints";
import { useSearchParams } from "react-router-dom";
import Typhography from "../../shared/Typhography/Typhography";
import { useCustomNavigate } from "../../hooks/useCustomNavigate";
import HeaderLogin from "../../shared/HeaderLogin/HeaderLogin";
import FooterLogin from "../../shared/FooterLogin/FooterLogin";
import ErrorIcon from "../../assets/icons/ErrorIcon";
import RegistrationForm from "./RegistrationForm";
import "./ConfirmDirector.scss";
import SuccessIcon from "../../assets/icons/SuccessIcon";
import CustomButton from "../../shared/CustomButton/CustomButton";
import { Spinner } from "@chakra-ui/react";

interface IConfirmCoach {}

const ConfirmCoach: FC<IConfirmCoach> = () => {
  const { checkConfirmToken, confirmDirector } = useEndpoints();
  const [searchParams] = useSearchParams();

  const [isLaoding, setisLaoding] = useState(false);
  const [statusCode, setStatusCode] = useState<number>();
  const { navigate } = useCustomNavigate();
  const confirmTokenRef = useRef<string>();
  const handleCheckToken = async () => {
    setisLaoding(true);
    try {
      const confirmToken = searchParams.get("confirmToken");

      if (!confirmToken) {
        setStatusCode(-1);
        return;
      }
      setStatusCode(-1);

      const [id, confirmedToken] = confirmToken.split("||||") as [
        string,
        string
      ];
      confirmTokenRef.current = confirmedToken;
      const { data } = await checkConfirmToken(id, confirmedToken);
      if (data?.code !== undefined) {
        setStatusCode(data.code);
      }
    } catch (error) {
    } finally {
      setisLaoding(false);
    }
  };

  useEffect(() => {
    handleCheckToken();
    // eslint-disable-next-line
  }, []);

  const onConfirmForm = async (form: any) => {
    setisLaoding(true);
    try {
      await confirmDirector({
        confirmedToken: confirmTokenRef.current!,
        ...form,
      });
      setStatusCode(10);
    } catch (error) {
      console.error("error", error);
    } finally {
      setisLaoding(false);
    }
  };
  const renderError = () => {
    return (
      <div className="d-flex align-items-center flex-column gap-3">
        <ErrorIcon w={16} h={16} color={"red.400"} />
        <Typhography size="bold-20">Errore inaspettato</Typhography>
      </div>
    );
  };

  const renderConfirmedToken = () => {
    return (
      <div className="d-flex align-items-center flex-column gap-3">
        <SuccessIcon w={16} h={16} color={"green.400"} />
        <Typhography size="bold-20">
          Account confermato con successo
        </Typhography>
        <CustomButton onClick={() => navigate("DIRECTOR_LOGIN")}>
          Accedi
        </CustomButton>
      </div>
    );
  };
  const renderStatusCode = useMemo(() => {
    if (isLaoding) {
      return <Spinner></Spinner>;
    }
    if (statusCode === undefined) return null;
    return {
      "-1": renderError(),
      "0": (
        <RegistrationForm statusCode={statusCode} onConfirm={onConfirmForm} />
      ),
      "1": (
        <RegistrationForm statusCode={statusCode} onConfirm={onConfirmForm} />
      ),
      "10": renderConfirmedToken(),
    }[statusCode];
    // eslint-disable-next-line
  }, [statusCode]);

  return (
    <div className="container__login">
      <div className="container__header">
        <HeaderLogin />
        <div id="container-form" className="container__form">
          {renderStatusCode}
        </div>
      </div>
      <div className="container__footer">
        <FooterLogin />
      </div>
    </div>
  );
};

export default ConfirmCoach;
